import { useShallow } from 'zustand/react/shallow'
import { useNavigate } from 'react-router'
import { useImpersonationStore } from '@/stores/impersonation'
import { useProfilesStore } from '@/stores/profiles'
import { ROUTES } from '@/constants/routes'

export default function ImpersonationBanner() {
  const navigate = useNavigate()
  const { targetUid, targetName, targetEmail, stopImpersonation } = useImpersonationStore(useShallow((s) => ({ targetUid: s.targetUid, targetName: s.targetName, targetEmail: s.targetEmail, stopImpersonation: s.stopImpersonation })))

  if (!targetUid) return null

  async function handleExit() {
    await stopImpersonation()
    useProfilesStore.setState({ loaded: false, loadedForUid: null, profiles: [] })
    navigate(ROUTES.COMMAND_CENTER_USERS)
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[2000] bg-danger-600 px-4 py-2 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        <i className="fa-solid fa-eye text-white text-sm flex-shrink-0" />
        <div className="min-w-0">
          <span className="text-sm font-semibold text-white">Viewing as </span>
          <span className="text-sm font-bold text-white">{targetName}</span>
          {targetEmail && <span className="text-xs text-white/70 ml-1.5 truncate hidden sm:inline">{targetEmail}</span>}
        </div>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <span className="text-[10px] font-semibold text-white/70 uppercase tracking-wide hidden sm:inline">Read-only</span>
        <button
          onClick={() => void handleExit()}
          className="rounded-lg bg-white/20 hover:bg-white/30 transition-colors px-3 py-1 text-xs font-bold text-white"
        >
          Exit
        </button>
      </div>
    </div>
  )
}
